import { z } from 'zod';

// The unsync-mark level of a «buzón», and nothing else. The wire also carries `box_id`, which is not
// modelled, so `z.object` strips it before it reaches a slice or the query cache — data minimization
// enforced by the parse, as BoxStatusSchema does.
//
// Mirrors the DELIVERED shape (CBX-11149, verified against app-service `5e01b0a3c`): `{box_id, mark}`
// and nothing more. The panel had asked for the five fields of the `admin` twin and backend chose to
// minimize instead, so `updated_at` and the two `initial_*_code_pointer` reference positions — which
// sit beside opening credentials — never leave the `panel` context at all. Belt and braces: this
// parse would strip them anyway if they were ever added back.
export const BoxMarksSchema = z.object({ mark: z.number().int().nonnegative() });

export type BoxMarks = z.infer<typeof BoxMarksSchema>;
